import React from 'react'

const CategoryFilter = (props) => {
  const filters = props.options.map((o) => {
    return (
      <div key={o.name} className="form-group ml-4">
        <input
          className="form-check-input"
          checked={o.checked}
          type={props.type}
          name={props.label}
          value={o.name}
          onChange={props.handleChange}
        />
        <label className="form-check-label">{o.label}</label>
      </div>
    )
  })

  return (
    <div className="col-12">
      <label
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#495057',
        }}
      >
        {props.label}
      </label>
      {filters}
    </div>
  )
}

export default CategoryFilter
